import { createFileRoute } from '@tanstack/react-router'

import WriteAdminKotaKabPage from '@/components/pages/backoffice/_user/_kabupaten/containers/WriteAdminKotaKab'

export const Route = createFileRoute(
  '/_backoffice/user/kabupaten/$adminId/edit'
)({
  component: AdminKabupatenPage
})

function AdminKabupatenPage() {
  const { adminId } = Route.useParams()

  return <WriteAdminKotaKabPage type="edit" userId={adminId} />
}
